import { render, staticRenderFns } from "./PropertiesInfo.vue?vue&type=template&id=c64600ac&scoped=true&"
import script from "./PropertiesInfo.vue?vue&type=script&lang=js&"
export * from "./PropertiesInfo.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesInfo.vue?vue&type=style&index=0&id=c64600ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64600ac",
  null
  
)

export default component.exports